<template>
    <div>
        <div class="flex items-center justify-between px-4 pt-4">
            <button
                class="btn btn-ghost btn-sm"
                @click="prevDay"
            >
                <AppIcon
                    name="chevron-left"
                    :size="22"
                />
            </button>
            <span class="text-sm font-medium">{{ formattedDate }}</span>
            <button
                class="btn btn-ghost btn-sm"
                :disabled="isToday"
                @click="nextDay"
            >
                <AppIcon
                    name="chevron-right"
                    :size="22"
                />
            </button>
        </div>
        <DailySummary
            :summary="dailySummary"
            class="p-4"
        />
        <Entries
            :entries="entries"
            class="p-4"
        />
    </div>
</template>

<script>
import Entries from 'components/home/entries.vue';
import DailySummary from 'components/home/DailySummary.vue';
import AppIcon from 'components/icons/app-icon.vue';
import apiClient from 'api/apiClient.js';

function localDateString(d = new Date()) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export default {
    name: 'HomeIndex',
    components: { AppIcon, DailySummary, Entries },
    props: {
        canMakeEntry: {
            type: Boolean,
            default: false,
        },
        entryProcessingId: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        selectedDate: localDateString(),
        entries: [],
        dailySummary: {
            total_calories: 0,
            total_protein: 0,
            total_carbs: 0,
            total_fat: 0,
            total_fiber: 0,
            total_sugar: 0,
        },
    }),
    computed: {
        isToday() {
            return this.selectedDate === localDateString();
        },
        formattedDate() {
            if (this.isToday) return 'Today';
            const d = new Date(this.selectedDate + 'T00:00:00');
            return d.toLocaleDateString('en-NL', { weekday: 'short', month: 'short', day: 'numeric' });
        },
    },
    created() {
        this.getEntries();
    },
    methods: {
        prevDay() {
            const d = new Date(this.selectedDate + 'T00:00:00');
            d.setDate(d.getDate() - 1);
            this.selectedDate = localDateString(d);
            this.getEntries();
        },
        nextDay() {
            if (this.isToday) return;
            const d = new Date(this.selectedDate + 'T00:00:00');
            d.setDate(d.getDate() + 1);
            this.selectedDate = localDateString(d);
            this.getEntries();
        },
        getEntries() {
            apiClient.get('/api/home', { date_: this.selectedDate }).then((response) => {
                this.entries = response.entries;
                this.dailySummary = response.daily_summary;
            });
        },
    },
};
</script>
